module.exports = __webpack_public_path__ + "static/img/u=951748870,1513419846&fm=253&fmt=auto&app=120&f=JPEG@2x.c5cb86f4.png";